import React from "react";

import { cn } from "@/lib/helpers/cn";

import "./styles.scss";

const Label = (props) => {
  return (
    <div>
      <label className={cn("Label", props.classes)}>{props.children}</label>
    </div>
  );
};

export default Label;
